export default "__VITE_ASSET__253eb192__"